import { z } from "zod";

/**
 * Le contrat de donnees de l'affiche du planning de stream, lu par les composants React du
 * frontal et copie tel quel dans l'image du service de rendu.
 *
 * Ce fichier n'importe que `zod` : rien d'autre ne doit y entrer, sans quoi l'image de rendu
 * ne pourrait plus le copier seul.
 */

export const FORMATS_AFFICHE = ["story", "paysage"] as const;
export const formatAfficheSchema = z.enum(FORMATS_AFFICHE);
export type FormatAffiche = z.infer<typeof formatAfficheSchema>;

export const GENRES_AVIS = ["jeu", "emission", "evenement", "off"] as const;

export const avisAfficheSchema = z.strictObject({
  /** « Lundi ». */
  jour: z.string().min(1).max(12),
  /** « 21h », « 21h30 » ; vide pour un creneau OFF. */
  heure: z.string().max(8),
  genre: z.enum(GENRES_AVIS),
  /** Le jeu, l'emission ou l'evenement ; vide pour OFF. */
  titre: z.string().max(140),
  /** Une cle de `visuels`, ou null quand il n'y a pas d'image. */
  visuel: z.string().max(80).nullable(),
  /** Le pseudo de l'invite, sans arobase, ou null. */
  invite: z.string().max(25).nullable(),
});
export type AvisAffiche = z.infer<typeof avisAfficheSchema>;

export const semaineAfficheSchema = z.strictObject({
  /** « du 1er au 7 septembre ». */
  libelle: z.string().min(1).max(60),
  avis: z.array(avisAfficheSchema).min(1).max(7),
  /** Par cle : une data URL (rendu) ou une adresse du meme site (apercu). */
  visuels: z.record(z.string().max(80), z.string().min(1).max(4_000_000)),
});
export type SemaineAffiche = z.infer<typeof semaineAfficheSchema>;

export const COMPOSITIONS = ["semaine-story", "semaine-paysage", "mesure-video"] as const;
export const SORTIES = ["png", "jpeg", "mp4"] as const;

export const demandeRenduSchema = z
  .strictObject({
    composition: z.enum(COMPOSITIONS),
    sortie: z.enum(SORTIES),
    semaine: semaineAfficheSchema,
  })
  .refine((d) => (d.composition === "mesure-video") === (d.sortie === "mp4"), {
    message: "mp4 pour mesure-video, png ou jpeg pour une affiche",
  });
export type DemandeRendu = z.infer<typeof demandeRenduSchema>;
